export function getMemberUpgradePath(plan) {
  const selectedPlan = plan === "vip" ? "vip" : "basic";
  return `/members/upgrade?plan=${selectedPlan}`;
}
